export function invitationIdFromSearch(search: string): string | null {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  for (const key of ["invitation", "invitationId"] as const) {
    const id = params.get(key)?.trim() ?? "";
    if (id) return id;
  }
  return null;
}
